import React, { Fragment, useEffect } from 'react';
import NavbarS3 from '../../components/NavbarS3/NavbarS3';
import AboutS2 from '../../components/aboutS2/aboutS2';
import FeaturesSection from '../../components/FeaturesSection/FeaturesSection';
import ServiceSectionS2 from '../../components/ServiceSectionS2/ServiceSectionS2';
import SkillSection from '../../components/SkillSection/SkillSection';
import CtaSection from '../../components/CtaSection/CtaSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import SImg from '../../images/skill2.jpg'
import HeroSection from '../../components/HeroSlider/Herosection';
import Ticker from '../../components/Metal/Ticker';
import PricingSection from '../../components/PricingSection/PricingSection';
import PartnersSection from '../../components/PartnersSection/PartnersSection';
import MessengerChatButton from '../../components/Messenger/ChatSection';
import VisitorService from '../../utils/VisitorTracker';


const HomePage = () => {
  // Track page view
  useEffect(() => {
    VisitorService.init();
  }, []);

    return (
        <Fragment>
            <NavbarS3 hclass={'wpo-site-header wpo-header-style-2'} />
            <HeroSection />
            <Ticker />
            <AboutS2 hclass={'wpo-about-area-s4 section-padding'}/>
            <MessengerChatButton />
            <FeaturesSection hclass={'wpo-features-area-s2 section-padding'} />
            <ServiceSectionS2 hclass={"wpo-service-area-s2"} ServiceBtn={true} />
            <PricingSection hclass={'wpo-about-area-s2 section-padding'} />
            <SkillSection hclass={'wpo-skill-section-s2 section-padding'} Akimg={SImg} />
            <PartnersSection hclass={'partners-section'}/>

 
            <CtaSection hclass={'wpo-subscribe-section-s2 section-bg'} />
            <Footer hclass={'wpo-site-footer-s2'} />
            <Scrollbar />
            {/* <ChatSection /> */}

        </Fragment>
    )
};
export default HomePage;